declare var ErrorHandler: any;

var Ajax = window.Ajax = (function () {

    var ajaxViewParsers = {};
    function addAjaxViewParser(parser: any, name?: string) {
        name = name || 'default';
        ajaxViewParsers[name] = parser;
    }

    interface IUnAuthorizedHandler {
        (data: any): void;
    }

    var unauthorizedHandlers: IUnAuthorizedHandler[] = [];

    function subscribeUnauthorized(handler: IUnAuthorizedHandler) {
        if (unauthorizedHandlers.indexOf(handler) < 0) {
            unauthorizedHandlers.push(handler);
        }
    }

    function unSubscribeUnauthorized(handler: IUnAuthorizedHandler) {
        var index = unauthorizedHandlers.indexOf(handler);
        if (index >= 0) {
            unauthorizedHandlers.splice(index, 1);
        }
    }

    var globalErrorHandler = (jqXHR, textStatus, errorThrown) => console.log('AjaxError Moq: ' + textStatus + ' ' + errorThrown);

    $(document).ready(function () {
        if (typeof (ErrorHandler) != 'undefined' && typeof (ErrorHandler.handle) == 'function')
            globalErrorHandler = ErrorHandler.handle;
    });

    function commonErrorHandler(jqXHR: JQueryXHR, textStatus: string, errorThrown: string, error: any) {
        if (textStatus == null) return;

        if (typeof (error) != 'function') error = globalErrorHandler;

        error(jqXHR, textStatus, errorThrown);
    }
    function callAjaxViewParsers(view: IAjaxView) {
        var parsers = Object.keys(ajaxViewParsers);
        for (var i = 0; i < parsers.length; i++) {
            callAjaxViewParser(ajaxViewParsers[parsers[i]], view);
        }
    }

    function callAjaxViewParser(parser: any, view: IAjaxView) {
        if (parser) {
            if (typeof (parser) == 'function') {
                parser(view);
            } else if (typeof (parser.parse) == 'function') {
                parser.parse(view);
            }
        }
    }

    function processViews(views: IAjaxView[], doCallAjaxViewParsers: boolean) {
        for (var i = 0; i < views.length; i++) {
            var view = views[i];

            $(view.Selector).promise().done(function () {
                $(view.Selector).replaceWith(view.Html);
                if (doCallAjaxViewParsers)
                    callAjaxViewParsers(view);
            });

            var afterRender = view.AfterRender;
            if (afterRender && afterRender.length > 0) {
                afterRender.forEach(function (act) {
                    var handler = eval(act.name);
                    handler.call(view, act.args);
                })
            }
        }
    }

    function commonSuccessHandler(data: IAjaxData, textStatus: string, jqXHR: JQueryXHR, success: any, doCallAjaxViewParsers: boolean) {
        if (data.RedirectUrl) {
            Ajax.redirect(data.RedirectUrl, data.ActionData);
            return;
        }

        if (data.Views && data.Views.length > 0) {
            processViews(data.Views, doCallAjaxViewParsers);
        }

        if (success && typeof (success) == 'function') {
            var notifyData = data.ActionData;
            if (data.IsUnauthorized === true) {
                notifyData = $.extend(true, {}, notifyData || {}, { IsUnauthorized: true });
            }

            success(notifyData, textStatus, jqXHR);
        }

        if (data.IsUnauthorized === true) {
            unauthorizedHandlers.forEach((handler, index, arr) => handler(data));
        }
    }

    function processUrl(url: string, data: any):string {
        const urlParams = new URLSearchParams(url);
        const sValue = urlParams.get('s');
        const queryParams = sValue || data
            ? `?${[sValue, $.param(data)].filter(Boolean).join('&')}`
            : '';
        return `${url}${queryParams}`;
    }
    function processUrlSearch(url: string): string {
        const urlParams = new URLSearchParams(window.location.search);
        const paramsObject = Object.fromEntries(urlParams.entries());
        return processUrl(url, paramsObject);
    }
    function postJson(url: string, options?: any) {
        options = options || {};
        options.dataType = 'json'; //text html or default(IG)
        options.method = 'POST';
        url = processUrlSearch(url);

        var dataToSend = options.data;
        if (typeof dataToSend == "string") {
            dataToSend = JSON.parse(dataToSend);
        }
        dataToSend = dataToSend || {};
        dataToSend.isAjax = true;
        options.data = dataToSend;

        if (!options.hasOwnProperty('async')) {
            options.async = true
        }

        var uiBlock = options.uiBlock;
        options.uiBlock = undefined;
        var uiBlockNeeded = UiBlock.needBlock(uiBlock);

        var concreteSuccessHandler = options.success;
        var concreteErrorHandler = options.error;
        options.error = (jqXHR, textStatus, errorThrown) => {
            if (uiBlockNeeded) UiBlock.unBlock(uiBlock);

            commonErrorHandler(jqXHR, textStatus, errorThrown, concreteErrorHandler);
        }

        var doCallAjaxViewParsers = options.hasOwnProperty('doCallAjaxViewParsers') ? options.doCallAjaxViewParsers : true;

        options.success = (data, textStatus, jqXHR) => {
            if (uiBlockNeeded) UiBlock.unBlock(uiBlock);

            commonSuccessHandler(data, textStatus, jqXHR, concreteSuccessHandler, doCallAjaxViewParsers);
        }

        if (uiBlockNeeded) UiBlock.block(uiBlock);

        return $.ajax(url, options);
    }
    function SubmitFileForm(element: HTMLElement): void {
        var form = $(element).parents('form')[0];
        var actionUrl = $(form).attr('action');
        actionUrl = processUrlSearch(actionUrl);
        var f: any = $(form);
        var validator = f.validate();


        if (f.valid()) {
            document.dispatchEvent(new CustomEvent('validationSuccess', {
                detail: {
                    validator
                }
            }))

            var formData = new FormData(f[0]);

            var uiBlock = UiBlock.getUiBlockDescriptor(element, UiBlock.getDefaultSpinnerBlock(element));
            UiBlock.block(uiBlock);

            $.ajax(actionUrl,
                {
                    url: actionUrl,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: (data, textStatus, jqXHR) => {
                        UiBlock.unBlock(uiBlock);

                        commonSuccessHandler(data, textStatus, jqXHR, null, true);
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        UiBlock.unBlock(uiBlock);
                    },
                    dataType: 'json'
                });
        } else {
            document.dispatchEvent(new CustomEvent('validationError', {
                detail: {
                    validator
                }
            }))
        }
    }

    function getJson(url: string, options?: JQueryAjaxSettings) {
        options = options || {};
        options.dataType = 'json'; //text html or default(IG)
        options.method = 'GET';
        options.async = true;
        url = processUrlSearch(url);

        var dataToSend = options.data || '';
        if (typeof dataToSend == "object" && Object.keys(dataToSend).length > 0) {
            dataToSend = $.param(dataToSend);
        }
        dataToSend.isAjax = true;
        options.data = dataToSend;
        var concreteSuccessHandler = options.success;
        var concreteErrorHandler = options.error;
        options.error = (jqXHR, textStatus, errorThrown) => commonErrorHandler(jqXHR, textStatus, errorThrown, concreteErrorHandler);
        options.success = (data, textStatus, jqXHR) => commonSuccessHandler(data, textStatus, jqXHR, concreteSuccessHandler, false);

        return $.ajax(url, options);
    }

    function redirect(url: string, data?: any) {
        window.location.href = processUrl(url, data);
    }

    function refreshPage() {
        document.location.reload();
    }

    function serializeObject(element: any) {
        var o = {};
        var a = $(element).serializeArray();
        var ignore = $.unique($(element).find('[form-submit-ignore]').find('input').filter(function () { return this.name; }).map((i, elem: any) => { return elem.name; }).get());
        $.each(a, function () {
            if (ignore.indexOf(this.name) != -1)
                return;

            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    function collectForm(element: any): any {
        var form = $(element).parents('form')[0];
        var f: any = $(form);

        var validator = f.validate();

        if (f.valid()) {
            document.dispatchEvent(new CustomEvent('validationSuccess', {
                detail: {
                    validator
                }
            }))

            return { form: Ajax.serializeObject(form), isValid: true };
        }
        else {
            document.dispatchEvent(new CustomEvent('validationError', {
                detail: {
                    validator
                }
            }))

            return { isValid: false };
        }
    }

    function submitByElement(element: HTMLElement) {
        var form = $(element).parents('form')[0];
        var actionUrl = $(form).attr('action');
        var f: any = $(form);
        if (f.valid()) {
            var data = Ajax.serializeObject(form);
            var uiBlock = UiBlock.getUiBlockDescriptor(element, UiBlock.getDefaultSpinnerBlock(element));

            Ajax.postJson(actionUrl, { data: data, uiBlock: uiBlock });
        }
    }

    function submit(selector: any) {
        var element;
        if (typeof (selector) == 'string') {
            element = $(selector)[0];
        } else if (typeof (selector) == 'object' && selector.tagName) {
            element = selector;
        }

        submitByElement(selector);
    }

    function ajaxAction(url, input) {
        var dataJson = $(input).attr('ajaxData');
        var data = null;
        if (dataJson) {
            data = JSON.parse(dataJson);
        }

        var uiBlock = UiBlock.getUiBlockDescriptor(input, UiBlock.getDefaultSpinnerBlock(input));

        Ajax.postJson(url, { data: data, uiBlock: uiBlock });
    }

    function init(lang: string, appSource: string) {
        var options = {
            headers: {
                'bb-ajax': '1',
                'bb_lang': lang
            }
        };
        if (window.globalAppSettings && window.globalAppSettings.api.authToken != "") {
            options.headers['Authorization'] = `Bearer ${window.globalAppSettings.api.authToken}`
        }
        if (appSource != null && appSource != undefined) {
            options.headers['bb_appSource'] = appSource;
        }
        $.ajaxSetup(options);
    }

    return {
        addAjaxViewParser,
        subscribeUnauthorized,
        unSubscribeUnauthorized,
        processViews,
        postJson,
        SubmitFileForm,
        getJson,
        redirect,
        refreshPage,
        serializeObject,
        collectForm,
        submit,
        ajaxAction,
        init
    }
})()